import { createFileRoute } from '@tanstack/react-router';

import { ButtonViewWrapper } from 'views/ButtonViewWrapper';

export const Route = createFileRoute('/_auth/_buttonView')({
  component: ButtonViewWrapper,
});
